import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  getUserdata,
  TransferUserToAnotherAdmin,
} from "../../../Services/Superadmin/Superadmin";
import { Getuserlistdata } from "../../../Services/Admin/Addmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import NoData from "../../../Utils/Table/errlogo.png";
import { set } from "date-fns";
const Admin = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [adminList, setAdminList] = useState([]);
  const [fromAdmin, setFromAdmin] = useState("");
  const [toAdmin, setToAdmin] = useState("");
  const [userNameList, setUserNameList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);


    const [page, setPage] = useState(1);
  const limit = 10;  // ek page me 10 users
  const [totalPages, setTotalPages] = useState(1);


  // Admin list fetch
  useEffect(() => {
    getAllAdmin();
  }, []);

  useEffect(() => {
    fetchUserList();
  }, [page,fromAdmin]);

  const getAllAdmin = async () => {
    try {
      const data = { id: user_id, page, limit };
      const response = await getUserdata(data);
      setAdminList(response.data || []);
    } catch (error) {
      console.error(error);
    }
  };

    

  // User list fetch
  const fetchUserList = async (Userid = fromAdmin) => {
    try {
       if (!Userid) return; 
      setFromAdmin(Userid);
      const data = {
         adminid: Userid,
          userId: "",
           status: 0,
            input: "" ,
           page: page,
       limit: limit
      };
      const response = await Getuserlistdata(data);
      if (response?.status) {
        setUserNameList(response.data);
       setTotalPages(Math.ceil(Number(response.totalUsers) / limit));
        setSelectedUsers([]);
        setSelectAll(false);
      } else {
        setUserNameList([]);
        setSelectedUsers([]);
        setSelectAll(false);
      }
    } catch (error) {
      console.error("User list fetch error:", error);
    }
  };

  const nextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const prevPage = () => {
    if (page > 1) setPage(page - 1);
  };

  // Handle single checkbox
  const handleCheckboxChange = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  // Handle select all
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]);
      setSelectAll(false);
    } else {
      const allIds = userNameList.map((u) => u._id);
      setSelectedUsers(allIds);
      setSelectAll(true);
    }
  };

  // Handle transfer
  const handleTransfer = async () => {
    if (!fromAdmin || !toAdmin) {
      Swal.fire("Error", "Please select both admins!", "error");
      return;
    }
    if (fromAdmin === toAdmin) {
      Swal.fire("Error", "From and To admin cannot be the same!", "error");
      return;
    }
    if (selectedUsers.length === 0) {
      Swal.fire("Error", "Please select at least one user!", "error");
      return;
    }

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `Selected ${selectedUsers.length} users will be transferred.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Transfer",
    });

    if (confirm.isConfirmed) {
      try {
        let Res = await TransferUserToAnotherAdmin({
          fromAdmin,
          toAdmin,
          selectedUsers: selectedUsers,
        });


        if (Res?.status === false) {
          return Swal.fire("Error", Res?.message, "error");
        }

        Swal.fire("Success", "Users transferred successfully!", "success");
        fetchUserList(fromAdmin); // Refresh user list after transfer
      } catch (err) {
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div
        className="card shadow-sm"
        style={{
          borderRadius: "14px",
          border: "none",
          backgroundColor: "#F7F7F7",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
        }}
      >

        <div className="card-header border-0">
          <h4 className="card-title p-2">👩‍💼 User Transfer</h4>
        </div>

        <div className="card-body">
          {/* Dropdowns */}
          <div className="row mb-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: "15px" }}>
                Transfer From
              </label>
              <select
                className="form-select"
                value={fromAdmin}
                onChange={(e) => fetchUserList(e.target.value)}
              >
                <option value="">-- Select Admin --</option>
                {adminList.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.UserName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold mb-1" style={{ fontSize: "15px" }}>
                Transfer To
              </label>
              <select
                className="form-select"
                value={toAdmin}
                onChange={(e) => setToAdmin(e.target.value)}
              >
                <option value="">-- Select Admin --</option>
                {adminList
                  .filter((item) => item._id !== fromAdmin) // 👈 यहाँ filter लगा दिया
                  .map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.UserName}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-md-4 d-flex align-items-end">
              <button
                className="btn btn-primary w-100 shadow-sm"
                style={{
                  padding: "10px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  letterSpacing: "0.3px",
                }}
                onClick={handleTransfer}
              >
                Transfer Selected Users
              </button>
            </div>
          </div>

          {/* User Table */}
          {/* <div className="table-responsive">
            <table className="table table-bordered ">
              <thead
                style={{
                  backgroundColor: "#2382e0ff",
                  color: "white",
                  border: "none",
                }}
              >
                <tr>
                  <th
                    style={{
                      width: "50px",
                      border: "none",
                      color: "white",
                      backgroundColor: "#16406bff",
                    }}
                  >
                    <input
                      style={{ width: "20px", height: "20px", color: "white", }}
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}

                    />
                  </th>

                  <th
                    style={{
                      border: "none",
                      backgroundColor: "#16406bff",
                      color: "white",
                    }}
                  >
                    UserName
                  </th>

                  <th
                    style={{
                      border: "none",
                      backgroundColor: "#16406bff",
                      color: "white",
                    }}
                  >
                    Balance
                  </th>
                </tr>
              </thead>

              <tbody >
                {userNameList.length === 0 && (
                  <tr>
                    <td colSpan="100%" className="text-center py-5">
                      <div>
                        <img src={NoData} style={{ width: "160px" }} />
                        <h4 className="text-muted mt-3">No Data Available</h4>
                      </div>
                    </td>
                  </tr>
                )}
                {userNameList.length > 0 ? (
                  userNameList.map((user) => (
                    <tr key={user._id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedUsers.includes(user._id)}
                          onChange={() => handleCheckboxChange(user._id)}
                        />
                      </td>
                      <td>{user.UserName}</td>
                      <td>{user.Balance}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> */}
            <div className="table-responsive">
            <table className="table table-bordered ">
              <thead
                style={{
                  backgroundColor: "#2382e0ff",
                  color: "white",
                  border: "none",
                }}
              >
                <tr>
                  <th
                    style={{
                      width: "50px",
                      border: "none",
                      color: "white",
                      backgroundColor: "#3529a1",
                    }}
                  >
                    <input
                      style={{ width: "20px", height: "20px", color: "white", }}
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}

                    />
                  </th>

                  <th
                    style={{
                      border: "none",
                      backgroundColor: "#3529a1",
                      color: "white",
                    }}
                  >
                    UserName
                  </th>

                  <th
                    style={{
                      border: "none",
                      backgroundColor: "#3529a1",
                      color: "white",
                    }}
                  >
                    Balance
                  </th>
                </tr>
              </thead>

              <tbody >
                {userNameList.length === 0 && (
                  <tr>
                    <td colSpan="100%" className="text-center py-2">
                    <div style={{ textAlign: "center", overflow: "hidden" }}>
                      <img src={NoData} className="nodata-combo" style={{ width: "250px" }} />
                      <h4 className="text-muted mt-3">No Data Available</h4>
                    </div>
                    </td>
                  </tr>
                )}
                {userNameList.length > 0 && (
                  userNameList.map((user) => (
                    <tr key={user._id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedUsers.includes(user._id)}
                          onChange={() => handleCheckboxChange(user._id)}
                        />
                      </td>
                      <td>{user.UserName}</td>
                      <td>{user.Balance}</td>
                    </tr>
                  ))
                ) }
              </tbody>
            </table>
          </div>
            {/* Pagination */}
      <div className="d-flex justify-content-end mt-4 gap-2">
        <button
          onClick={prevPage}
          disabled={page === 1}
          className="btn  btn-outline-primary"
          
        >
          Prev
        </button>

        <span className="px-2 mt-2">
          Page <b>{page}</b> of <b>{totalPages}</b>
        </span>

        <button
          onClick={nextPage}
          disabled={page === totalPages}
          className="btn  btn-outline-primary"
        >
          Next
        </button>
      </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
